import React from 'react';
import cl from './NewsInfo.module.css';
import { NavLink } from 'react-router-dom';

const NewsInfo = (props) => {
  
    return (
        <section className={cl.news}>
          <NavLink to={props.path}>
            <img src={props.newsImg}/>
            <p>{props.newsName}</p>
          </NavLink>
      </section>
    ); 
}

export default NewsInfo;